import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Icon, Modal } from 'semantic-ui-react';

import './ViewListModal.scss';

const ViewListModal = ({ title, data, extractor }) => {
  const { t } = useTranslation();
  const [modal, setModal] = useState(false);
  const toggle = () => {
    setModal(!modal);
  };

  return (
    <Modal
      open={modal}
      closeIcon={<Icon onClick={toggle} name="close" className="closeicon" />}
      size="small"
      className="dept-list-modal"
      trigger={
        <label onClick={toggle} className="view-container-goals">
          {t('actions.view')}
        </label>
      }
    >
      <Modal.Header>{title}</Modal.Header>
      <Modal.Content>
        <div className="goal-list-view">
          {data.map((elem) => (
            <label className="dept-label">{extractor(elem)}</label>
          ))}
        </div>
      </Modal.Content>
    </Modal>
  );
};

export { ViewListModal };
